module.exports = __webpack_public_path__ + "img/admin.3dc24eac.svg";